export default {
  data() {
    return {
      selectedIdOptions: [],
      selectedOptions: [],
    }
  },
  methods: {
    //清空当前页选中数据
    clearData() {
      let delList = [];
      if (this.dataList.tableData.length) {
        delList = this.dataList.tableData.map(item => item.taskId);
      }
      this.selectedIdOptions = this.selectedIdOptions.filter(
        item => !delList.includes(item)
      );
      this.selectedOptions = this.selectedOptions.filter(item => !delList.includes(item.id || item.unionId))
    },
    // 全选
    selectAll(data) {
      if (!data || !data.length) {
        this.clearData()
      }
    },
    // 单个选择
    handleSelectionChange(data) {
      if (data.length) {
        this.clearData()
        let selected = data.map(item => item.taskId);
        this.selectedIdOptions = Array.from(
          new Set(this.selectedIdOptions.concat(selected))
        );
        this.selectedOptions = this.selectedOptions.concat(data)
        this.selectedOptions = [...new Map(this.selectedOptions.map(obj => [obj.id || obj.unionId, obj])).values()];
      } else {
        this.clearData()
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/reportproblemAnalysis/page-change-select.js